import { request } from "../../app/api-client/ApiClient";

export function findAllPoll(page, size) {

	return request({
		url:`${process.env.REACT_APP_API_BASCULA}/v1/poll?page=${page}&size=${size}`,
		method:"GET"
	})

}

export function findResultPollById(idPoll) {

	return request({
		url: `${process.env.REACT_APP_API_BASCULA}/v1/poll/${idPoll}/result`,
		method: "GET",
	});
}

export function findResultPollByIdBascula(idPoll, idBs) {

	return request({
		url: `${process.env.REACT_APP_API_BASCULA}/v1/poll/result/pollAndBascula/${idPoll}/${idBs}`,
		method: "GET",
	});

}


export function createNewPollService(Request) {
	let url = `${process.env.REACT_APP_API_BASCULA}/v1/poll/create`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	});
}





export function createNewClosedQuestionPoll(Request) {
	let url = `${process.env.REACT_APP_API_BASCULA}/v1/question/create/options`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	});
}


